import { Link } from '@tanstack/react-router';
import Logo from '../common/components/Logo';
// import { SocialIcon } from 'react-social-icons';
// import colors from 'tailwindcss/colors';

function Footer() {
    return (
        <div className=' grid h-16 w-full border-t-2 border-green-500 bg-white  font-normal text-gray-800'>
            <div className='mx-auto flex w-[95%] flex-col items-center justify-between md:w-[70%] md:flex-row'>
                <div className=' flex w-full flex-row items-center justify-between gap-4 text-xs md:justify-normal  md:text-sm'>
                    <Link className='hover:underline' to='/'>
                        Home
                    </Link>
                    <Link className='hover:underline' to='/blog'>
                        Blog
                    </Link>
                    <Link className='hover:underline' to='/privacy-policy'>
                        Privacy Policy
                    </Link>
                    <Link className='hover:underline' to='/terms-and-conditions'>
                        Terms & Conditions
                    </Link>
                    <Link className='hover:underline' to='/'>
                        Caddy Stats LLC
                    </Link>
                    {/* <SocialIcon
                        bgColor={colors.green[500]}
                        url='www.instagram.com'
                        className='h-2 scale-75'
                    /> */}
                </div>
                <div className='flex flex-row items-center text-xs font-normal md:text-sm'>
                    <div>© 2025 Caddy Stats LLC. All rights reserved.</div>

                    <div className=' h-10 w-10 justify-self-end p-1'>
                        <Link to='/'>
                            <Logo />
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Footer;
